export default "/static/media/icon-arrow-forward.aa958187.svg";